import { render, staticRenderFns } from "./Snack.vue?vue&type=template&id=6cdc6fbb"
import script from "./Snack.vue?vue&type=script&lang=ts"
export * from "./Snack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports